
import type ArticleBodySection from "@/src/_types/Article/article-body-section";
import RecursiveContent from "@/src/components/journal-site/articles/article-body/article-body-content";
import { Box, Typography } from "@mui/material";

const ArticleBody = (
  { 
    articleBody,
  }: {
    articleBody: ArticleBodySection[] | undefined;
  }
) => (
  <Box>
    {
      articleBody && articleBody.map((section, index) => (
        ( section.content && section.content.length > 0 ) &&
        <Box key={index}>
          <Typography 
            component="h3"
            fontSize={'1.5rem'} 
            sx={{ marginBlockEnd: '0 !important' }}
          >
            {section.title}
          </Typography>
          <RecursiveContent
            content={section.content || {}}
          />
        </Box>
      ))
    }
  </Box>
);

export default ArticleBody;